const initialState = {
  list: [],
  total: "",
  searchKey: "",
};

const ManageCategoryListReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case "MANAGE_ALL_CATEGORY_RESPONSE":
      return {
        ...state,
        list: [...action.data.list],
        total: action.data.total,
      };

    default:
      return state;
  }
};

export default ManageCategoryListReducer;
